
import { computed, defineComponent, ref } from "vue";
import { usePlace } from "@/modules/thuyloi/composables/usePlace";
import CheckboxComponent from "@/components/ui/CheckboxComponent.vue";
import IconComponent from "@/components/ui/IconComponent.vue";
import TooltipComponent from "@/components/ui/TooltipComponent.vue";

export default defineComponent({
  name: "SidebarMap",
  components: {
    CheckboxComponent,
    IconComponent,
    TooltipComponent
  },
  props: {},
  methods: {
    onSelectZone(zone: any) {
      const {
        getDischargeWaterPoint,
        getAutomaticMeasuringStations,
        selectedZones
      } = usePlace();
      if (zone.show) {
        selectedZones.value.push(zone);
      } else {
        selectedZones.value = selectedZones.value.filter(
          (n: { id: any }) => n.id !== zone.id
        );
      }

      getDischargeWaterPoint();
      getAutomaticMeasuringStations();
    }
  },
  setup() {
    const disable = ref(false);
    const selected = ref(-1);
    const selectedSpecial = ref(-1);
    const onClickMenu = (index: any) => {
      if (selected.value === index) selected.value = -1;
      else {
        selectedSpecial.value = -1;
        selected.value = index;
      }
    };
    const onClickMenuSpecial = (index: any) => {
      if (selectedSpecial.value === index) selectedSpecial.value = -1;
      else {
        selectedSpecial.value = index;
        selected.value = -1;
      }
    };
    const {
      places,
      zones,
      toggleWQI,
      toggleDischargeWater,
      toggleDrain,
      toggleDam,
      togglePumpStation,
      toggleAutomaticMeasuringStation,
      dischargeWaterPoints,
      drains,
      dams,
      pumpStations,
      automaticMeasuringStations,
      markerSelected,
      getValueAllPlaceWithDataType,
      removeValueAllPlaceWithDataType,
      getDischargeWaterPoint,
      getDrains,
      getDams,
      getPumpStations,
      getAutomaticMeasuringStations
    } = usePlace();

    const onClickSwitch = async (type: any, toggle: any) => {
      if (!toggle) await getValueAllPlaceWithDataType(type.data_type_id);
      else await removeValueAllPlaceWithDataType(type.data_type_id);
    };

    const onClickDischargeWater = ($event: any) => {
      toggleDischargeWater.value = $event.target.checked;
      if ($event.target.checked) {
        getDischargeWaterPoint();
      } else {
        dischargeWaterPoints.value = [];
      }
    };

    const onClickDrain = ($event: any) => {
      toggleDrain.value = $event.target.checked;
      if ($event.target.checked) {
        getDrains();
      } else {
        drains.value = [];
      }
    };

    const onClickDam = ($event: any) => {
      toggleDam.value = $event.target.checked;
      if ($event.target.checked) {
        getDams();
      } else {
        dams.value = [];
      }
    };

    const onClickPumpStation = ($event: any) => {
      togglePumpStation.value = $event.target.checked;
      if ($event.target.checked) {
        getPumpStations();
      } else {
        pumpStations.value = [];
      }
    };

    const onClickAutomaticMeasuringStation = ($event: any) => {
      toggleAutomaticMeasuringStation.value = $event.target.checked;
      if ($event.target.checked) {
        getAutomaticMeasuringStations();
      } else {
        automaticMeasuringStations.value = [];
      }
    };

    const groupsPlace = computed(() => {
      const groups = [
        {
          title: "Độ chua phèn",
          ids: [1],
          data: [{ data_type_id: 1, show: false, label: "pH" }]
        },
        {
          title: "Độ mặn",
          ids: [],
          data: []
        },
        {
          title: "Ô nhiễm kim loại nặng",
          ids: [23],
          data: [{ data_type_id: 23, show: false, label: "Sắt (Fe)" }]
        },
        {
          title: "Ô nhiễm",
          ids: [],
          data: []
        },
        {
          title: "Ô nhiễm hữu cơ",
          ids: [4, 2, 3],
          data: [
            { data_type_id: 4, show: false, label: "Ôxy hòa tan (DO)" },
            { data_type_id: 2, show: false, label: "BOD5 (20°C)" },
            { data_type_id: 3, show: false, label: "COD" }
          ]
        },
        {
          title: "Ô nhiễm dinh dưỡng",
          ids: [6, 10, 9, 11],
          data: [
            { data_type_id: 6, show: false, label: "Amoni (NH4+ tính theo N)" },
            {
              data_type_id: 10,
              show: false,
              label: "Nitrat (NO-3 tính theo N)"
            },
            {
              data_type_id: 9,
              show: false,
              label: "Nitrit (NO-2 tính theo N)"
            },
            {
              data_type_id: 11,
              show: false,
              label: "Phosphat (PO43- tính theo P)"
            }
          ]
        },
        {
          title: "Ô nhiễm vi sinh",
          ids: [35],
          data: [{ data_type_id: 35, show: false, label: "Coliform" }]
        },
        {
          title: "Khác",
          ids: [
            5,
            7,
            8,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            36
          ],
          data: [
            {
              data_type_id: 5,
              show: false,
              label: "Tổng chất rắn lơ lửng (TSS)"
            },
            { data_type_id: 7, show: false, label: "Clorua (Cl-)" },
            { data_type_id: 8, show: false, label: "Florua (F-)" },
            { data_type_id: 12, show: false, label: "Xyanua (CN-)" },
            { data_type_id: 13, show: false, label: "Asen (As)" },
            { data_type_id: 14, show: false, label: "Cadimi (Cd)" },
            { data_type_id: 15, show: false, label: "Chì (Pb)" },
            { data_type_id: 16, show: false, label: "Crom VI (Cr6+)" },
            { data_type_id: 17, show: false, label: 'Tổng Crom"' },
            { data_type_id: 18, show: false, label: "Đồng (Cu)" },
            { data_type_id: 19, show: false, label: "Kẽm (Zn)" },
            { data_type_id: 20, show: false, label: "Niken (Ni)" },
            { data_type_id: 21, show: false, label: "Mangan (Mn)" },
            { data_type_id: 22, show: false, label: "Thủy ngân (Hg)" },
            { data_type_id: 24, show: false, label: "Chất hoạt động bề mặt" },
            { data_type_id: 25, show: false, label: "Aldrin" },
            {
              data_type_id: 26,
              show: false,
              label: "Benzene hexachloride (BHC)"
            },
            { data_type_id: 27, show: false, label: "Dieldrin" },
            {
              data_type_id: 28,
              show: false,
              label: "Tổng Dichloro diphenyl trichloroethane (DDTS)"
            },
            {
              data_type_id: 29,
              show: false,
              label: "Heptachlor & Heptachlorepoxide"
            },
            { data_type_id: 30, show: false, label: "Tổng Phenol" },
            {
              data_type_id: 31,
              show: false,
              label: "Tổng dầu, mỡ (oils & grease)"
            },
            {
              data_type_id: 32,
              show: false,
              label: "Tổng các bon hữu cơ (Total Organic Carbon, TOC)"
            },
            { data_type_id: 33, show: false, label: "Tổng hoạt độ phóng xạ α" },
            { data_type_id: 34, show: false, label: "Tổng hoạt độ phóng xạ β" },
            { data_type_id: 36, show: false, label: "E.coli" }
          ]
        }
      ];
      return groups;
    });
    const zoom1 = ref("");
    const zoom2 = ref("");
    const zoom3 = ref("");

    return {
      zoom1,
      zoom2,
      zoom3,
      places,
      groupsPlace,
      disable,
      zones,
      markerSelected,
      selected,
      selectedSpecial,
      toggleWQI,
      toggleDischargeWater,
      toggleDrain,
      toggleDam,
      togglePumpStation,
      toggleAutomaticMeasuringStation,
      onClickMenuSpecial,
      onClickMenu,
      onClickSwitch,
      onClickDischargeWater,
      onClickDrain,
      onClickDam,
      onClickPumpStation,
      onClickAutomaticMeasuringStation
    };
  }
});
